import React from 'react'
import { Component } from '../types/component'
import { cn } from '../lib/utils'

interface VideoProps {
  component: Component
  style: React.CSSProperties
}

export function Video({ component, style }: VideoProps) {
  const config = component.config as any
  const src = config.src
  const videoType = config.videoType || 'direct'
  const autoplay = config.autoplay || false
  const loop = config.loop || false
  const muted = config.muted || false
  const controls = config.controls !== false

  const videoStyle: React.CSSProperties = {
    ...style,
    width: style.width || undefined,
    height: style.height || undefined,
  }

  const className = cn(
    'border-0',
    !style.width && 'w-full',
    !style.height && videoType === 'direct' ? 'h-auto' : 'h-96'
  )

  // YouTube embed
  if (videoType === 'youtube') {
    const videoId = src.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/)?.[1]
    if (videoId) {
      return (
        <iframe
          style={videoStyle}
          className={className}
          src={`https://www.youtube.com/embed/${videoId}${autoplay ? '?autoplay=1' : ''}`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      )
    }
  }

  // Vimeo embed
  if (videoType === 'vimeo') {
    const videoId = src.match(/vimeo\.com\/(\d+)/)?.[1]
    if (videoId) {
      return (
        <iframe
          style={videoStyle}
          className={className}
          src={`https://player.vimeo.com/video/${videoId}${autoplay ? '?autoplay=1' : ''}`}
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
        />
      )
    }
  }

  // Direct video
  return (
    <video
      style={videoStyle}
      className={className}
      src={src}
      autoPlay={autoplay}
      loop={loop}
      muted={muted}
      controls={controls}
    />
  )
}
